
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: 'formular::pflanzenschutzmittel',
        titel: null,
        modelname: 'Pflanzenschutzmittel',
        model: 'pflanzenschutzmittel'
      },
      model: null
    }
  },
  computed: {},
  watch: {},
  methods: {
    fillModel(model = null) {
      if (!model) model = {};
      let empty = {
        name: '',
        manuell_hinzugefuegt: true,
      };
      this.model = this.$fillMissing(model, empty);
    },
  },

}
